export type QuestionID =
  | 'account-first-name-v1'
  | 'account-last-name-v1'
  | 'account-preferred-name-v1'
  | 'care-recipient-consent-v1'
  | 'care-recipient-first-name-v1'
  | 'care-recipient-last-name-v1'
  | 'care-recipient-consent-v1'
  | 'care-recipient-type-v1'
  | 'care-recipient-hours-per-week-v1'
  | 'care-recipient-symptoms-and-conditions-v1'
  | 'care-recipient-date-of-birth-v1'
  | 'care-recipient-postcode-v1';

export type QuestionResponse = {
  questionID: QuestionID;
  response: string;
};

/** The triage questions the app answers on someone's behalf, by what each asks. */
export const TRIAGE_QUESTION_ID = {
  careRecipientType: 'care-recipient-type-v1',
  careRecipientFirstName: 'care-recipient-first-name-v1',
  careRecipientLastName: 'care-recipient-last-name-v1',
} as const satisfies Record<string, QuestionID>;
